(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-studio-disclaimer"] && !Shopify.designMode) return;
  try {
    
  // Responsive slider controls (1–3 cards per view) with autoslide
  (function(){
    var sectionEl = document.querySelector('.rs-luxeC7[data-section-id]');
    if(!sectionEl) return;
    var id = sectionEl.getAttribute('data-section-id');
    var grid = document.getElementById("rs-grid-" + id);
    if(!grid) return;

    var prevBtn = document.querySelector('[data-prev="' + id + '"]');
    var nextBtn = document.querySelector('[data-next="' + id + '"]');

    function inCarouselMode(){
      var bp = parseInt(sectionEl.getAttribute('data-bp') || '1100');
      return window.matchMedia("(max-width:" + bp + "px)").matches;
    }

    function cardsPerView(){
      // Favor 2-up for most mid widths; 3-up only near breakpoint
      var w = grid.clientWidth || window.innerWidth;
      var bp = parseInt(sectionEl.getAttribute('data-bp') || '1100');
      if(w >= (bp - 80)) return 3; // e.g., 1020–1100 when bp=1100
      if(w >= 680) return 2;      // default mid range
      return 1;
    }

    function applyCardsPerView(){
      // Always set the CSS variable based on container width;
      // it only affects layout in carousel mode via CSS.
      var per = cardsPerView();
      grid.style.setProperty('--per', String(per));
      return per;
    }

    function cardWidth(){
      var per = cardsPerView();
      var viewport = grid.clientWidth || window.innerWidth;
      return (viewport / (per || 1));
    }

    function currentIndex(){
      // Round to nearest card index
      var w = cardWidth();
      return Math.round(grid.scrollLeft / (w || 1));
    }

    function clamp(v, min, max){ return Math.max(min, Math.min(max, v)); }

    function goTo(index){
      var total = grid.children.length;
      index = clamp(index, 0, total - 1);
      var w = cardWidth();
      grid.scrollTo({ left: index * w, behavior: "smooth" });
      updateButtons(index, total);
    }

    function updateButtons(index, total){
      if(!prevBtn || !nextBtn) return;
      if(!inCarouselMode()){
        prevBtn.disabled = true; nextBtn.disabled = true; return;
      }
      prevBtn.disabled = (index <= 0);
      nextBtn.disabled = (index >= total - 1);
    }

    // Click handlers
    if(prevBtn){ prevBtn.addEventListener("click", function(){ goTo(currentIndex() - 1); }); }
    if(nextBtn){ nextBtn.addEventListener("click", function(){ goTo(currentIndex() + 1); }); }

    // Keyboard support when grid is focused
    grid.addEventListener("keydown", function(e){
      if(!inCarouselMode()) return;
      if(e.key === "ArrowRight"){ e.preventDefault(); goTo(currentIndex() + 1); }
      if(e.key === "ArrowLeft"){ e.preventDefault(); goTo(currentIndex() - 1); }
    });

    // Utility: is the grid horizontally scrollable?
    function isScrollable(){ return (grid.scrollWidth - grid.clientWidth) > 2; }

    // Sync button states on scroll/resize
    var onScroll = function(){ if(inCarouselMode()) updateButtons(currentIndex(), grid.children.length); };
    var onResize = function(){
      // Recompute per-view and snap to nearest index to avoid half-cards
      applyCardsPerView();
      if(inCarouselMode()){ goTo(currentIndex()); startAuto(); } else { updateButtons(0, grid.children.length); stopAuto(); }
    };
    grid.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);
    if('ResizeObserver' in window){
      var ro = new ResizeObserver(function(){ onResize(); });
      ro.observe(grid);
    }

    // Autoslide
    var autoTimer = null;
    function startAuto(){
      var enabledAttr = sectionEl.getAttribute('data-autoslide-enabled');
      var enabled = (enabledAttr === 'true' || enabledAttr === '1');
      if(!enabled) return;
      stopAuto();
      if(!inCarouselMode() || !isScrollable()) return;
      autoTimer = setInterval(function(){
        if(!inCarouselMode()) return;
        var idx = currentIndex();
        var total = grid.children.length;
        var per = cardsPerView();
        if(!isScrollable()) return; // nothing to slide
        if(idx >= total - 1){ idx = -1; }
        goTo(idx + 1);
      }, parseInt(sectionEl.getAttribute('data-autoslide-interval') || '5000'));
      // Prime an initial tick a bit sooner to confirm motion
      var initialDelay = Math.min(1200, parseInt(sectionEl.getAttribute('data-autoslide-interval') || '5000'));
      setTimeout(function(){ if(inCarouselMode() && isScrollable()) goTo(currentIndex() + 1); }, initialDelay);
    }
    function stopAuto(){ if(autoTimer){ clearInterval(autoTimer); autoTimer = null; } }

    // Pause on hover/focus for accessibility
    var pauseOnHover = (sectionEl.getAttribute('data-autoslide-pause') === 'true');
    if(pauseOnHover){
      grid.addEventListener('mouseenter', stopAuto);
      grid.addEventListener('mouseleave', startAuto);
    }
    grid.addEventListener('focusin', stopAuto);
    grid.addEventListener('focusout', startAuto);

    // Initialize
    applyCardsPerView();
    updateButtons(0, grid.children.length);
    // Kick autoslide a moment after layout to ensure widths are final
    setTimeout(startAuto, 50);
  })();
  
  } catch(e) { console.error(e); }
})();
})();
